import Paper, { paperClasses } from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
const PaperRoot = styled(Paper, {
  shouldForwardProp: prop => prop !== 'variant'
})(_ref => {
  let {
    variant,
    theme: {
      shadows,
      shape
    }
  } = _ref;
  return {
    ["&.".concat(paperClasses.root)]: {
      borderRadius: variant === 'filled' || variant === 'standard' ? "0 0 ".concat(shape.borderRadius, "px ").concat(shape.borderRadius, "px") : shape.borderRadius,
      boxShadow: shadows[8],
      marginTop: 0
    }
  };
});
export default PaperRoot;